import { render, staticRenderFns } from "./ProductBrandIcon.vue?vue&type=template&id=5f9c8881&"
import script from "./ProductBrandIcon.vue?vue&type=script&lang=js&"
export * from "./ProductBrandIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports